<template>
<div class="password-input">
    <div class="password-toggle" @click="show_password = !show_password">
        <span v-show="show_password"><i class="material-icons">visibility</i></span>
        <span v-show="!show_password"><i class="material-icons">visibility_off</i></span>
    </div>

    <input class="full"
        :required="required"
        :id="id"
        :name="(label) ? label : id"
        :value="inputValue"
        :type="show_password ? 'text' : 'password'"
        @input="onChange" />
</div>
</template>

<script>
export default {
    name: "password-input",

    props: [
        "id",
        "inputValue",
        "label",
        "required"
    ],

    data () {
        return {
            show_password: false
        }
    },

    methods: {
        /**
         * When the input has changed, send an event to update the parent.
         *
         * @param Event ev Event object
         *
         * @return null
         */
        onChange: function (ev) {
            this.$emit("change", ev.currentTarget.value)
        }
    }
}
</script>

<style>
.password-input {
    position: relative;
}

.password-input .password-toggle {
    cursor: toggle;
    user-select: none;
    position: absolute;
    right: 10px;
    top: calc(50%);
    transform: translateY(-50%);
    z-index: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/PasswordInput.vue